import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { UserService } from '../../services/user/user.service';
import { StateManagementService } from '../../services/statemanagement/statemanagement.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'conversion-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css'],
})
export class SignInComponent implements OnInit, OnDestroy {
  subscription: Subscription | undefined;

  constructor(
    private readonly userService: UserService,
    private readonly stateManagementService: StateManagementService
  ) {}

  ngOnInit(): void {
    // The spinner stays visible until navigation replaces this page, avoiding an empty flash.
    this.subscription = this.userService
      .verifyClientAccess()
      .pipe(take(1))
      .subscribe((hasAccess) => {
        if (hasAccess) {
          this.stateManagementService.postLoginRedirect();
        }
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}